module.exports = function findImage(rel, mediaType = "media--image") {
	let image;
	let file;
	let media_caption = rel.attributes ? rel.attributes.field_caption : null;
	if (rel.relationships) {
		for (const [rel_key, rel_data] of Object.entries(rel.relationships)) {
			if (
				rel_data.data &&
				rel_data.data.type == "file--file" &&
				(((mediaType === "media--image" || mediaType === "media--private_image") &&
					rel_key !== "thumbnail") ||
					(mediaType !== "media--image" &&
						mediaType !== "media--private_image" &&
						rel_key === "thumbnail"))
			) {
				file = rel_data.data;
				if (rel_data.data.meta) {
					image = rel_data.data.meta;
				} else {
					image = {};
				}

				const src = file?.attributes?.image_style_uri?.crop_thumbnail
					? file?.attributes?.image_style_uri?.crop_thumbnail
					: `${process.env.CLF_BACKEND_URL}${file?.attributes?.uri?.url || ""}`;
				const href = file?.attributes?.uri?.url
					? `${process.env.CLF_BACKEND_URL}${file?.attributes?.uri?.url}`
					: null;
				const alt = image.alt ? image.alt : rel_data?.data?.attributes?.name;
				let caption = media_caption
					? media_caption
					: image.title
					? image.title
					: image.description;
				if (caption) {
					let rich_caption = caption.split("|");
					if (rich_caption.length === 2) {
						caption = `<em>${rich_caption[0]}</em> ${rich_caption[1]}`;
					}
				}
				let format = src.split(".").pop();
				if (format.includes("?")) {
					format = format.split("?")[0];
				}
				return { ...image, src, href, format, alt, caption };
			}
		}
	}
	return null;
};
